import * as React from "react";
import "./error.scss";

interface ErrorProps {
    message: string | React.ReactNode;
}

export default function Error(props: ErrorProps): React.ReactElement {
    return (
        <span className="error-message" data-testid="error-message">
            {props.message}
        </span>
    );
}
